import App from '@nokia-csf-uxr/ccfk/App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import HeaderWLD from './components/HeaderWLD';
import WLD from './WLD';
import { Navigate } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from "@azure/msal-react";

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import LinkForm from './components/Links/LinkForm';
import LoginScreen from './components/LoginScreen/LoginScreen';
import { AccountContext } from './contexts/AccountContext';
import Budget from './components/Budget/Budget';
import BoQ from './components/BoQ/BoQ';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CONFIG } from './config';
import NotAuthorizedPage from './components/NotAuthorizedPage';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Image, Alert } from 'react-bootstrap';

const MSAL_INSTANCE = new PublicClientApplication(CONFIG.msalConfig);

/**
 * ROUTER
 */
const ROUTER = createBrowserRouter([
  {
    path: "/",
    element:  (
      <>
      <AuthenticatedTemplate>
      <HeaderWLD/>
      <WLD/>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
      <Navigate to="/login" replace={true} />      
      </UnauthenticatedTemplate>
      </>
    ),
  },
  {
    path: "/error",
    element: <>
    <UnauthenticatedTemplate>
      <NotAuthorizedPage/>
    </UnauthenticatedTemplate>
    
    <AuthenticatedTemplate>
      <Navigate to="/" replace={true} />      
      </AuthenticatedTemplate>
    </>
  },
  {
    path: "/login",
    element: <LoginScreen/>,
  },
  {
    path: "/link/:id",
    element:  (
      <>
      <AuthenticatedTemplate>
      <HeaderWLD/>
      <LinkForm />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
      <Navigate to="/login" replace={true} />      
      </UnauthenticatedTemplate>
      </>
    ),
  },
  {
    path: "/link/:id/budget",
    element:  (
      <>
      <AuthenticatedTemplate>
      <HeaderWLD/>
      <Budget />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
      <Navigate to="/login" replace={true} />      
      </UnauthenticatedTemplate>
      </>
    ),
  },
  {
    path: "/link/:id/boq",
    element:  (
      <>
      <AuthenticatedTemplate>
      <HeaderWLD/>
      <BoQ />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
      <Navigate to="/login" replace={true} />      
      </UnauthenticatedTemplate>
      </>
    ),
  },  {
    path: "/link/create/:dual",
    element:  (
      <>
      <AuthenticatedTemplate>
      <HeaderWLD/>
      <LinkForm/>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
      <Navigate to="/login" replace={true} />      
      </UnauthenticatedTemplate>
      </>
    ),
  }
]);

/**
 * RENDER APP & initialization of the authentification variables
 */
class WLDApp extends React.Component<{},any> {

  constructor(props: {}) {
    super(props);

    // Store the data in the local storage of the user's browser
    let accountStorage = window.localStorage.getItem('account_state');
    this.state = accountStorage != null ? JSON.parse(accountStorage) : {
        token: "",
        accountId: 0,
        adId: "",
        isExpired: false,
        displayName: "",
        roles: []
    }

    // Initialization of the functions to define the values above
    const CURRENT_STATE = this;
    this.state = {
      ...(this.state),
      setToken: function(value: string) {
        CURRENT_STATE.setState({token: value})
      },
      setAccountID(value: number) {
        CURRENT_STATE.setState({accountId: value})
      },
      setIsExpired(value: boolean) {
        CURRENT_STATE.setState({isExpired: value})
      },
      setAdID(value: string) {
        CURRENT_STATE.setState({adId: value})
      },
      setDisplayName(value: string) {
        CURRENT_STATE.setState({displayName: value})
      },
      setRoles(value: string[]) {
        CURRENT_STATE.setState({roles: value})
      },
      setLoading: function(value: boolean) {
        CURRENT_STATE.setState({loading: value})
      }
    }
  }

  /**
   * New function like setSate of ReactJS but store in local storage the values
   * @param state New values
   */
  setState(state: { json?: any; margin?: number; token?: string; accountId?: number; isExpired?: boolean; adId?: string; displayName?: string; roles?: string[], loading?: boolean }) {
    let data = JSON.parse(window.localStorage.getItem('account_state') || "{}");
    data = {
      ...data,
      ...state
    }
    window.localStorage.setItem('account_state', JSON.stringify(data));
    super.setState(data);
  }

  /**
   * Clear session storage to redirect user to the login page
   */
  forceLogout() {
    localStorage.clear()
    sessionStorage.clear()
    document.location.href = "/"
  }

  render() {

    return (
        <App>
          <MsalProvider instance={MSAL_INSTANCE}>
            <AccountContext.Provider value={ this.state }>
              <RouterProvider router={ROUTER} />
            </AccountContext.Provider>
          </MsalProvider>
          <ToastContainer />

          <Modal show={this.state.isExpired}>
            <Modal.Header>
              <Modal.Title>Session time out</Modal.Title>
            </Modal.Header>
            <Modal.Body className='text-center'>
              <Alert key="warning" variant="warning">
                Your session is expired, please reconnect.
              </Alert>

              <Image className="w-25" src="/assets/icons/alarm.svg" fluid />

            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => this.forceLogout()}>
                Ok
              </Button>
            </Modal.Footer>
          </Modal>
        </App>
    );
  }
}

const ROOT = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
ROOT.render(<WLDApp/>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
